import {useState, createContext, useContext} from "react";

// import {availableBaseLayers} from "base/component/geo";

let MainContext = createContext(null);

export function MainAppProvider({children}) {
    //const [selectedBaseLayer, setSelectedBaseLayer] = useState(availableBaseLayers[0]);
    const [selectedBaseLayer, setSelectedBaseLayer] = useState(null);

    let value = {
        selectedBaseLayer,
        setSelectedBaseLayer,
    };

    return <MainContext.Provider value={value}>{children}</MainContext.Provider>;
}

export function useMainAppConfig() {
    return useContext(MainContext);
}
